// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1-cb3","range":"MonthRangeSwitch_range__1W_KS","disabled":"MonthRangeSwitch_disabled__3nLFK"};